import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { PAGE_NAMES, ROLES_TYPE } from '../../../core/helpers/constants';
import { getRolesForPage } from '../../../core/helpers/utility';
import { UtilityService } from '../../../core/helpers/utility.service';
import { IClient } from '../../../core/models/clients.models';
import { IAdsReportEmailModel } from '../../../core/models/reporting.models';
import { AppService } from '../../../store/app.service';
import { ReportsApiService } from '../reports.apiservice';

@Component({
  selector: 'app-weekly-reports',
  templateUrl: './weekly-reports.component.html',
  styleUrls: ['./weekly-reports.component.scss']
})
export class WeeklyReportsComponent implements OnInit, OnDestroy {
  active = 1;
  
  roleOptions: any = {};
  isAdmin: boolean = false;
  public userRoles: Array<number> = [];
  isExternal: boolean = false;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  constructor(
    public uService: UtilityService,
    private appService: AppService,
    private translate: TranslateService,
    private reportsService: ReportsApiService) {
    this.userRoles = [...this.uService.getUserRoles()];
    //this.campaignsData = new Array<ICampaign>();
  }

  ngOnInit(): void {
    if (!this.appService.getPageTitle$().getValue()) {
      this.appService.setPageTitle$('REPORTS');
    }
    this.appService.setRefreshSignal$(PAGE_NAMES.ClientDetails, '');

    this.adsReportsTableColumns = [
      { title: 'CLIENT', field: 'client', searchable: true },
      /* { title: 'Email', field: 'toEmail', searchable: true }, */
      { title: 'COMPANY', field: 'company', searchable: true },
      { title: 'REPORT_TYPE', field: 'reportType', searchable: true, translate: true },
      { title: 'ROLLUP', field: 'isRollup', searchable: true, translate: true },
      { title: 'PLATFORMS_LABEL', field: 'platforms', searchable: true },
      { title: 'CAMPAIGNS', field: 'campaigns', searchable: true },
    ];

    this.getWeeklyReportsData();

    this.appService.getActiveUser$()
      .pipe(takeUntil(this.destroyed$))
      .subscribe(u => {
        this.isExternal = u.type == ROLES_TYPE.External
        var r = getRolesForPage(u.roles, PAGE_NAMES.Clients);
        this.isAdmin = r.isAdmin;
        if (r.options)
          this.roleOptions = JSON.parse(r.options!);
      })
  }

  //adsReportsTableData: Array<IReportingConfig> = [];
  adsReportsTableColumns: Array<any> = [];
  adsReportsTableData = new Array<IWeeklyReportRow>();

  getWeeklyReportsData(): void {
    this.adsReportsTableData = []; 

    this.reportsService.getWeeklyReportsModels()
      .subscribe(res => {
        let configs: Array<IWeeklyReportRow> = [];

        let clientData = res.data as Array<IClientEmailModel>;
        clientData
          .forEach(client => {

            client.adsReports.forEach(report => {

              let c = {
                id: report.id /* Need this column as part of table so that when on delete we can access the list of IDs that were selected*/,
                client: client.fullName,
                company: client.brand,
                reportType: report.isAdvancedReport ? 'ADVANCED' : 'SIMPLE',
                isRollup: report.isRollup === true ? 'COMMON.YES' : 'COMMON.NO',
                platforms: report.campaigns.filter((n: any, i: any) => report.campaigns.indexOf(n) === i).map(m => m.platform).join(', \r\n'),
                campaigns: report.campaigns.filter((n: any, i: any) => report.campaigns.indexOf(n) === i).map(m => m.name).join(', \r\n'),
                toEmail: report.toEmail ?? client.email,
                reportEmailModel: report,
              };
              configs.push(c);
            });

          });
        this.adsReportsTableData = configs;

      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  ToEmails: string = ''; // 'denzil@atlastech.dev';
  CCEmails: string = '';
  Error: string = '';

  @ViewChild('toEmailElement') toEmailElement: ElementRef = {} as ElementRef;
  oSendEmail(event: any) {
    this.Error = '';
    if (!this.ToEmails || this.ToEmails == '') {
      this.toEmailElement.nativeElement.focus();
      this.toEmailElement.nativeElement.select();
      this.Error = this.translate.instant('WEEKLY_REPORTS_INVALID_TO_EMAIL_TEST_RUN');
      return;
    }

    var reportEmailModel = event.reportEmailModel as IAdsReportEmailModel;
    // console.log(reportEmailModel);

    let reportModels = [reportEmailModel];

    // let subject = 'Custom subject';

    let x: { to: string, ccs?: string, subject?: string, reportModels: Array<IAdsReportEmailModel> };
    x = { to: this.ToEmails, ccs: this.CCEmails, reportModels: reportModels };

    this.reportsService.sendSingleWeeklyReport(x)
      .subscribe(
        (res: any) => {
          let errors = res.data ? res.data : '';
          const hasErrors = !!errors;
          Swal.fire(
            this.translate.instant(hasErrors ? 'WEEKLY_REPORTS_SENT_WITH_ERRORS' : 'WEEKLY_REPORTS_SENT'),
            errors,
            'success',
          );
        },
        (error: HttpErrorResponse) => {
          console.error(error.error);

          this.toEmailElement.nativeElement.focus();
          this.toEmailElement.nativeElement.select();
          this.Error = error.error?.data;
        }
      );
  }

} 

export interface IWeeklyReportRow {
  id: string;
  client: string;
  company: string;
  reportType: string;
  isRollup: string;
  platforms: string;
  campaigns: string;
  toEmail: string;
  reportEmailModel: IAdsReportEmailModel;
}

export interface IClientEmailModel extends IClient {
  adsReports: Array<IAdsReportEmailModel>,
}
